import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { OnboardingStep, FadeUp, ScaleIn } from './OnboardingStep';
import { useIsMobile } from '@/hooks/use-mobile';

interface StepIdentityProps {
  displayName: string;
  setDisplayName: (name: string) => void;
  onNext: () => void;
}

export function StepIdentity({ displayName, setDisplayName, onNext }: StepIdentityProps) {
  const isMobile = useIsMobile();
  const isValid = displayName.trim().length > 0 && displayName.length <= 50;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid) onNext();
  };

  return (
    <OnboardingStep>
      <FadeUp delay={0.2}>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-3">
          Welcome to Luma.
        </h1>
      </FadeUp>
      
      <FadeUp delay={0.4}>
        <p className="text-xl text-muted-foreground mb-16">
          Let's get started.
        </p>
      </FadeUp>
      
      <FadeUp delay={0.6}>
        <p className="text-lg text-foreground mb-8">
          What should we call you?
        </p>
      </FadeUp>
      
      <form onSubmit={handleSubmit} className="w-full space-y-10">
        <ScaleIn delay={0.8} className="w-full">
          <Input
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Your name"
            maxLength={50}
            className="h-14 text-lg text-center bg-background/50 border-border/50 backdrop-blur-sm focus:border-primary/50 transition-colors"
            autoFocus={!isMobile}
          />
        </ScaleIn>
        
        <ScaleIn delay={1.0} className="w-full">
          <Button
            type="submit"
            size="lg"
            disabled={!isValid}
            className="w-full h-14 text-lg font-medium"
          >
            Continue
          </Button>
        </ScaleIn>
      </form>
    </OnboardingStep>
  );
}
